import { useEffect, useState } from "react";
import fr from "./assets/terms-and-conditions.fr.md?raw";
import en from "./assets/terms-and-conditions.en.md?raw";
import { Markdown } from "./Markdown";
import { i18n } from "@thetreep/ui";

export function TermsAndConditions() {
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const onLanguageChanged = (lng: string) => setLanguage(lng);
    i18n.on("languageChanged", onLanguageChanged);
    return () => i18n.off("languageChanged", onLanguageChanged);
  }, []);

  if (language === "fr") return <Markdown content={fr} />;
  if (language === "en") return <Markdown content={en} />;
  return null;
}
